/**
 * Avatar Color Cache
 * Генерирует и кеширует уникальные цвета аватаров на основе хеша email пользователя
 */

class AvatarColorCache {
  private static instance: AvatarColorCache;
  private cache = new Map<string, string>();
  
  static getInstance(): AvatarColorCache {
    if (!AvatarColorCache.instance) {
      AvatarColorCache.instance = new AvatarColorCache();
    }
    return AvatarColorCache.instance;
  }
  
  /**
   * Получить цвет для email (из кеша или сгенерировать новый)
   */
  getColor(email: string): string {
    if (!email) return this.getDefaultColor();
    
    if (this.cache.has(email)) {
      return this.cache.get(email)!;
    }
    
    const color = this.generateColor(email);
    this.cache.set(email, color);
    return color;
  }
  
  /**
   * Генерирует цвет на основе хеша email
   */
  private generateColor(email: string): string {
    const hash = email.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
    
    // Генерируем HSL цвет с фиксированной насыщенностью и яркостью
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 80%)`; // Светлые пастельные тона
  }
  
  /**
   * Цвет по умолчанию для случаев без email
   */
  private getDefaultColor(): string {
    return 'hsl(240, 70%, 80%)'; // Фиолетовый по умолчанию
  }
  
  /**
   * Очистка кеша
   */
  clear(): void {
    this.cache.clear();
  }
  
  /**
   * Удаление записи из кеша для конкретного email
   */
  removeEmail(email: string): void {
    this.cache.delete(email);
  }
  
  /**
   * Обновление email в кеше (при изменении email пользователя)
   */
  updateEmail(oldEmail: string, newEmail: string): void {
    if (oldEmail && this.cache.has(oldEmail)) {
      this.cache.delete(oldEmail);
    }
    // Новый цвет будет сгенерирован при следующем обращении к getColor(newEmail)
  }
  
  /**
   * Получение статистики кеша
   */
  getStats(): { size: number; emails: string[] } {
    return {
      size: this.cache.size,
      emails: Array.from(this.cache.keys())
    };
  }
}

export const avatarColorCache = AvatarColorCache.getInstance(); 